import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AdminInfoMailFacade } from './admin-info-mail.facade';
import { InfoMailState, InfoMailTemplateDto } from '@models/resources/info-mail.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante des Info-Mail-Bereichs (User-Feedback 2026-08).
 * Wire-Shape matched das BE 1:1 (`Admin\InfoMailController`).
 */
@Injectable()
export class HttpAdminInfoMailFacade implements AdminInfoMailFacade {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/info-mail`;

  get(): Observable<InfoMailState> {
    return this.http.get<InfoMailState>(this.base);
  }

  saveTemplate(dto: InfoMailTemplateDto): Observable<InfoMailState> {
    return this.http.put<InfoMailState>(this.base, dto);
  }

  uploadAttachment(file: File): Observable<InfoMailState> {
    return this.http.post<InfoMailState>(`${this.base}/attachments`, this.fileForm(file));
  }

  deleteAttachment(id: number): Observable<InfoMailState> {
    return this.http.delete<InfoMailState>(`${this.base}/attachments/${id}`);
  }

  uploadAgb(file: File): Observable<InfoMailState> {
    return this.http.post<InfoMailState>(`${this.base}/agb`, this.fileForm(file));
  }

  uploadSampleOrder(file: File): Observable<InfoMailState> {
    return this.http.post<InfoMailState>(`${this.base}/sample-order`, this.fileForm(file));
  }

  private fileForm(file: File): FormData {
    const form = new FormData();
    form.append('file', file, file.name);
    return form;
  }
}
